<!--start section header-->
 
 <header class="head">
    <div class="cover-cont">
        <div class="container d-flex justify-content-center align-items-center pt-5">
         <div>
             <h2 class="pt-5 d-flex justify-content-center">
                Gallery Carousel 1 column
             </h2>
             <nav aria-label="breadcrumb">
                 <ol class="breadcrumb d-flex justify-content-center">
                   <li (click) = change() class="breadcrumb-item">
                       <a>Home</a>
                     </li>
                   <li class="breadcrumb-item active" aria-current="page">Gallery Carousel 1 column</li>
                 </ol>
             </nav>
         </div>
 
        </div>
    </div>
 
 </header>
 
 <!--end section header-->





<!--start section Gallery Carousel-->  

<section class="container py-5 ">
    <div data-slick='{"slidesToShow": 1, "slidesToScroll": 1}' class="one-time pt-4 gallery-arousel">
        
              <div class="cover">
                  <div class="cont">
                     <img src="assets/images/b.jpg" class="w-100" alt="drugs">
                     <i class="fas fa-search icons"></i>
                     <div class="cover-bg"></div>
                  </div>
                  <div class="text-center cover-footer pb-5">
                      <ul class="list-unstyled pt-3">
                          <li class="p1">Medical</li>
                          <li class="p2">Morbi euismod</li>
                      </ul>
                      <p>
                        Vivamus enim justo, suscipit laoreet odio id, interdum egestas sapien. Phasellus ultricies felis lectus, sed condimentum <br>
                         libero condimentum eget. 
                      </p>
                  </div>
              </div>
              <div class="cover">
                <div class="cont">
                   <img src="assets/images/e.jpg" class="w-100" alt="drugs">
                   <i class="fas fa-search icons"></i>
                   <div class="cover-bg"></div>
                </div>
                <div class="text-center cover-footer pb-5">
                    <ul class="list-unstyled pt-3">
                        <li class="p1">Clinic</li>
                        <li class="p2">Vestibulum libero</li>
                    </ul>
                    <p>
                        Vivamus enim justo, suscipit laoreet odio id, interdum egestas sapien. Phasellus ultricies felis lectus, sed condimentum <br>
                         libero condimentum eget. 
                      </p>
                </div>
            </div>
            <div class="cover">
                <div class="cont">
                   <img src="assets/images/h.jpg" class="w-100" alt="drugs">
                   <i class="fas fa-search icons"></i>
                   <div class="cover-bg"></div>
                </div>
                <div class="text-center cover-footer pb-5">
                    <ul class="list-unstyled pt-3">
                        <li class="p1">Dental</li>
                        <li class="p2">Pellentesque commodo</li>
                    </ul>
                    <p>
                        Vivamus enim justo, suscipit laoreet odio id, interdum egestas sapien. Phasellus ultricies felis lectus, sed condimentum <br>
                         libero condimentum eget. 
                      </p>
                </div>
            </div>
            <div class="cover">
                <div class="cont">
                   <img src="assets/images/m.jpg" class="w-100" alt="drugs">
                   <i class="fas fa-search icons"></i>
                   <div class="cover-bg"></div>
                </div>
                <div class="text-center cover-footer pb-5">
                    <ul class="list-unstyled pt-3">
                        <li class="p1">Pharmacists</li>
                    <li class="p2">Lorem ipsum</li>
                    </ul>
                    <p>
                        Vivamus enim justo, suscipit laoreet odio id, interdum egestas sapien. Phasellus ultricies felis lectus, sed condimentum <br>
                         libero condimentum eget. 
                      </p>
                </div>
            </div>
            <div class="cover">
                <div class="cont">
                   <img src="assets/images/i.jpg" class="w-100" alt="drugs">
                   <i class="fas fa-search icons"></i>
                   <div class="cover-bg"></div>
                </div>
                <div class="text-center cover-footer pb-5">
                    <ul class="list-unstyled pt-3">
                        <li class="p1">Medical</li>
                    <li class="p2">Sarmiento museum</li>
                    </ul>
                    <p>
                        Vivamus enim justo, suscipit laoreet odio id, interdum egestas sapien. Phasellus ultricies felis lectus, sed condimentum <br>
                         libero condimentum eget. 
                      </p>
                </div>
            </div>
            <div class="cover">
                <div class="cont">
                   <img src="assets/images/w.jpg" class="w-100" alt="drugs">
                   <i class="fas fa-search icons"></i>
                   <div class="cover-bg"></div>
                </div>
                <div class="text-center cover-footer pb-5">
                    <ul class="list-unstyled pt-3">
                        <li class="p1">Clinic</li>
                    <li class="p2">Proin imperdiet</li>
                    </ul>
                    <p>
                        Vivamus enim justo, suscipit laoreet odio id, interdum egestas sapien. Phasellus ultricies felis lectus, sed condimentum <br>
                         libero condimentum eget. 
                      </p>
                </div>
            </div>
            <div class="cover">
                <div class="cont">
                   <img src="assets/images/z.jpg" class="w-100" alt="drugs">
                   <i class="fas fa-search icons"></i>
                   <div class="cover-bg"></div>
                </div>
                <div class="text-center cover-footer pb-5">
                    <ul class="list-unstyled pt-3">
                        <li class="p1">Dental</li>
                        <li class="p2">Aenean varius</li>
                    </ul>
                    <p>
                        Vivamus enim justo, suscipit laoreet odio id, interdum egestas sapien. Phasellus ultricies felis lectus, sed condimentum <br>
                         libero condimentum eget. 
                      </p>
                </div>
            </div>
            <div class="cover">
                <div class="cont">
                   <img src="assets/images/r.jpg" class="w-100" alt="drugs">
                   <i class="fas fa-search icons"></i>
                   <div class="cover-bg"></div>
                </div>
                <div class="text-center cover-footer pb-5">
                    <ul class="list-unstyled pt-3">
                        <li class="p1">Pharmacists</li>
                        <li class="p2">Praesent eleifend</li>
                    </ul>
                    <p>
                        Vivamus enim justo, suscipit laoreet odio id, interdum egestas sapien. Phasellus ultricies felis lectus, sed condimentum <br>
                         libero condimentum eget. 
                      </p>
                </div>
            </div>
            
    </div>
        
</section>


<!--end section Gallery Carousel--> 
